module.exports = __webpack_public_path__ + "static/videos/collage2.b89ba1a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/collage2.mp4
// module id = b20Y
// module chunks = 1